import { render, staticRenderFns } from "./expand-search.vue?vue&type=template&id=08ead245&scoped=true"
import script from "./expand-search.vue?vue&type=script&lang=js"
export * from "./expand-search.vue?vue&type=script&lang=js"
import style0 from "./expand-search.vue?vue&type=style&index=0&id=08ead245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ead245",
  null
  
)

export default component.exports